import type { ThemeType } from "@pandas/core-ui";
import { StateCreator } from "zustand";
import { Storage } from "../index";

export interface LayoutSlice {
	error: Error | unknown | null;
	themeMode: ThemeType;
	displayLanguageSelector: boolean;
	helperAction: null | (() => void);
	setHelperIconAction: (action: null | (() => void)) => void;
	setDisplayLanguageSelector: (value: boolean) => void;
	setThemeMode: (themeMode: ThemeType) => void;
	setError: (error: Error | unknown | null) => void;
	clearError: () => void;
}

const initialState = {
	error: null,
	displayLanguageSelector: true,
	themeMode: "light" as ThemeType,
	helperAction: null,
};
export const createLayoutSlice: StateCreator<Storage, [], [], LayoutSlice> = (set) => ({
	...initialState,
	setHelperIconAction: (action: null | (() => void)) => set(() => ({ helperAction: action })),
	setDisplayLanguageSelector: (value: boolean) => set(() => ({ displayLanguageSelector: value })),
	setThemeMode: (themeMode: ThemeType) =>
		set(() => ({
			themeMode,
		})),
	setError: (error: Error | unknown | null) =>
		set(() => ({
			error,
		})),
	clearError: () => set(() => ({ error: null })),
});
